var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eds-task-agree-root"},[_c('v-textarea',{ref:"refNote",class:[{ 'hide-message': _vm.hiddenMessage }],attrs:{"required":"","label":_vm.$t('请输入审批意见'),"clearable":true,"solo":"","flat":"","auto-grow":"","autofocus":""},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }